import { GreetingOnlyHttpOnlyParameter } from "@app/profile/models";
import { createAction, props } from "@ngrx/store";

export const updateOnlyParameter = createAction(
  "[Profile Questions Settings] Update only parameter",
  props<{ only: GreetingOnlyHttpOnlyParameter }>(),
);

export const updateHashParameter = createAction(
  "[Profile Questions Settings] Update hash parameter",
  props<{ hash_id: string | null }>(),
);
